const normalizeReference = (value) => String(value ?? '').trim().toLowerCase()
const toNumber = (value) => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export const calculatePoClaims = ({ invoices, creditNotes, projectId, poId, poNumber, poValue }) => {
  const targetPoNumber = normalizeReference(poNumber)
  const poInvoices = invoices.filter((invoice) => {
    if (Number(invoice.project_id) !== Number(projectId)) return false
    if (!poId && !targetPoNumber) return false

    const invoicePoNumber = normalizeReference(
      invoice.PurchaseOrder?.po_number || invoice.po_number_ref || invoice.po_number
    )
    return (poId && String(invoice.po_id) === String(poId)) ||
      (targetPoNumber && invoicePoNumber === targetPoNumber)
  })
  const invoiceIds = new Set(poInvoices.map((invoice) => String(invoice.invoice_id)))
  const invoiceNumbers = new Set(poInvoices.map((invoice) => normalizeReference(invoice.invoice_number)).filter(Boolean))
  const totalInvoiced = poInvoices.reduce((sum, invoice) => sum + toNumber(invoice.invoice_amount), 0)
  const totalCreditNotes = creditNotes.reduce((sum, creditNote) => {
    const invoiceId = creditNote.invoice_id ?? creditNote.Invoice?.invoice_id
    const invoiceNumber = normalizeReference(creditNote.invoice_number_ref || creditNote.Invoice?.invoice_number)
    if (!invoiceIds.has(String(invoiceId)) && !(invoiceNumber && invoiceNumbers.has(invoiceNumber))) return sum
    return sum + toNumber(creditNote.amount_rm)
  }, 0)
  const currentClaimed = Math.max(0, totalInvoiced - totalCreditNotes)
  const value = toNumber(poValue)
  const remainingClaimable = Math.max(0, value - currentClaimed - totalCreditNotes)

  return {
    totalInvoiced,
    totalCreditNotes,
    currentClaimed,
    remainingClaimable,
    remainingPercentage: value > 0 ? (remainingClaimable / value) * 100 : 0
  }
}
